import * as v from 'valibot';
import { Metadata } from './metadata';
export var UserSchema;
(function (UserSchema) {
    const Email = v.pipe(v.string(), v.email());
    const FullName = v.pipe(v.string(), v.minLength(3));
    const Password = v.pipe(v.string(), v.minLength(8), v.maxLength(72), v.regex(/^[\x20-\x7e]+$/, 'Пароль може містити лише друковані ASCII-символи'));
    const OptionalPassword = v.pipe(v.string(), v.transform(value => (value.length > 0 ? value : undefined)), v.undefinedable(Password));
    UserSchema.User = v.pipe(v.object({
        id: v.number(),
        fullName: FullName,
        email: Email,
        permissions: v.array(v.string()),
        createdAt: v.string(),
        updatedAt: v.string()
    }), v.transform(input => ({
        ...input,
        createdAt: new Date(input.createdAt),
        updatedAt: new Date(input.updatedAt)
    })));
    UserSchema.Settings = v.object({
        fullName: FullName,
        email: Email,
        password: OptionalPassword
    });
    UserSchema.Register = v.object({
        email: Email,
        fullName: FullName,
        password: Password,
        permission: v.union([v.literal('admin'), v.literal('publisher')])
    });
    UserSchema.Edit = v.object({
        email: Email,
        fullName: FullName,
        permission: v.union([v.literal('admin'), v.literal('publisher')])
    });
    UserSchema.ResetPasswordRequest = v.object({
        password: Password
    });
    UserSchema.ResetPassword = v.pipe(v.object({
        password: Password,
        passwordConfirmation: Password
    }), v.forward(v.partialCheck([['password'], ['passwordConfirmation']], input => input.password === input.passwordConfirmation, 'Паролі не збігаються'), ['passwordConfirmation']));
    UserSchema.DetailResponse = v.object({
        user: UserSchema.User
    });
    UserSchema.Filters = v.object({
        page: v.optional(v.pipe(v.number(), v.minValue(1)))
    });
    UserSchema.ListResponse = v.object({
        users: v.array(UserSchema.User),
        metadata: Metadata
    });
    UserSchema.Login = v.object({
        password: v.pipe(v.string(), v.minLength(8)),
        email: v.pipe(v.string(), v.email())
    });
})(UserSchema || (UserSchema = {}));
